export default {
  PhoneTypeFormField__ARIA: "Phone type",
  PhoneTypeFormField__HOME: "Home",
  PhoneTypeFormField__LABEL: "Phone type",
  PhoneTypeFormField__MOBILE: "Mobile",
  PhoneTypeFormField__OTHER: "Other",
  PhoneTypeFormField__RADIO_BUTTON_ARIA_LIVE: (data) =>
    `RadioButton group. ${data.option} option selected. ${data.index} of ${data.length}`,
  PhoneTypeFormField__REQUIRED_ERROR: "Select Phone type",
  PhoneTypeFormField__WORK: "Work",
};
